import $ from 'jquery';
import _ from 'underscore';
import Backbone from "backbone";
import Utils from "models/helper/Utils";
import PeakMeterWidgetViewTemplate from 'text!../../../templates/common/PeakMeterWidgetViewTemplate.html';
import RSVP from 'rsvp';

const PeakMeterWidgetView = Backbone.View.extend({



    initialize : function(options) {
        this.compiledTemlate =  _.template(PeakMeterWidgetViewTemplate);
        this._isMeterRunning = false;
        this._meterValue = null;
        this._meterAnimationFrameId = null;
        this._mediaStreamAudioSourceNode = null;
        this._analyserNode = null;
    },
    
    events : {
        
    },

    isStarted : function(){
        return this._isMeterRunning;
    },

    startMeter: function(stream, audioContext){
        this.stopMeter();
        this.stream = stream;
        this.audioContext = audioContext;
        if(!stream || !audioContext || !audioContext.createMediaStreamSource){
            return;
        }

        this._isMeterRunning = true;
        const buildAnalyserPipeline = (function() {
            this._disconnectMeterNodes();
            this._mediaStreamAudioSourceNode = audioContext.createMediaStreamSource(stream);
            this._analyserNode = audioContext.createAnalyser();
            this._mediaStreamAudioSourceNode.connect(this._analyserNode);
            this._analyserNode.fftSize = 2048;
            this._analyserNode.smoothingTimeConstant = 0.2;
            return new Float32Array(this._analyserNode.fftSize);
        }).bind(this);

        const startMeterLoop = (function() {
            let sampleBuffer = null;
            try{
                sampleBuffer = buildAnalyserPipeline();
            }catch(error){
                console.error("Unable to initialize the peak meter", error);
                this._updateMeterValueWithDBValue(-60, -60);
                this._isMeterRunning = false;
                return;
            }

            const onFrame = (function(){
                if(this.stream === stream && this.audioContext === audioContext){
                    if(audioContext.state === "closed"){
                        this._updateMeterValueWithDBValue(-60, -60);
                        this._isMeterRunning = false;
                        this._disconnectMeterNodes();
                        return;
                    }

                    if(audioContext.state === "suspended"){
                        if(audioContext.resume){
                            audioContext.resume().catch(function(error){
                                console.warn("Unable to resume the audio context while the peak meter is running", error);
                            });
                        }
                        this._updateMeterValueWithDBValue(-60, -60);
                        if(this._isMeterRunning){
                            this._meterAnimationFrameId = window.requestAnimationFrame(onFrame);
                        }
                    }else{
                        this._analyserNode.getFloatTimeDomainData(sampleBuffer);

                        let sumOfSquares = 0;
                        for (let i = 0; i < sampleBuffer.length; i++) {
                            sumOfSquares +=  Math.pow(sampleBuffer[i], 2);
                        }
                        const avgPowerDecibels = 10 * Math.log10(sumOfSquares / sampleBuffer.length);

                        let peakInstantaneousPower = 0;
                        for (let i = 0; i < sampleBuffer.length; i++) {
                            const power = Math.pow(sampleBuffer[i], 2);
                            peakInstantaneousPower = Math.max(power, peakInstantaneousPower);
                        }
                        const peakInstantaneousPowerDecibels = 10 * Math.log10(peakInstantaneousPower);

                        this._updateMeterValueWithDBValue(Math.max(avgPowerDecibels, peakInstantaneousPowerDecibels), -60);
                        if(this._isMeterRunning){
                            this._meterAnimationFrameId = window.requestAnimationFrame(onFrame);
                        }
                    }
                }
            }).bind(this);

            this._meterAnimationFrameId = window.requestAnimationFrame(onFrame);
        }).bind(this);

        const ensureAudioContextReadyPromise = audioContext.state === "suspended" && audioContext.resume ? audioContext.resume() : RSVP.Promise.resolve();
        RSVP.Promise.resolve(ensureAudioContextReadyPromise).then(startMeterLoop).catch((function(error){
            console.warn("Unable to start the peak meter because the audio context could not be resumed", error);
            if(this._isMeterRunning){
                startMeterLoop();
            }else{
                this._updateMeterValueWithDBValue(-60, -60);
            }
        }).bind(this));
    },

    _disconnectMeterNodes: function() {
        if(this._mediaStreamAudioSourceNode && this._mediaStreamAudioSourceNode.disconnect){
            try{
                this._mediaStreamAudioSourceNode.disconnect();
            }catch(error){
                console.warn("Unable to disconnect the peak meter source node", error);
            }
        }
        if(this._analyserNode && this._analyserNode.disconnect){
            try{
                this._analyserNode.disconnect();
            }catch(error){
                console.warn("Unable to disconnect the peak meter analyser node", error);
            }
        }
        this._mediaStreamAudioSourceNode = null;
        this._analyserNode = null;
    },

    stopMeter : function(){
        this._isMeterRunning = false;
        if(this._meterAnimationFrameId){
            window.cancelAnimationFrame(this._meterAnimationFrameId);
            this._meterAnimationFrameId = null;
        }
        this._disconnectMeterNodes();
        this._updateMeterValueWithDBValue(-60, -60);
    },



    _updateMeterValueWithDBValue : function(currentDbValue, floorDbValue){
        if(floorDbValue > currentDbValue){
            currentDbValue = floorDbValue;
        }
        const meterValue  = (floorDbValue * (-1) + currentDbValue) * 100 /Math.abs(floorDbValue);
        const clampedMeterValue = Math.max(0, Math.min(100, isFinite(meterValue) ? meterValue : 0));
        this._meterValue = clampedMeterValue;
        const normalizedLevel = clampedMeterValue / 100;
        let peakState = "idle";

        if(normalizedLevel >= 0.92){
            peakState = "danger";
        }else if(normalizedLevel >= 0.78){
            peakState = "warning";
        }else if(normalizedLevel > 0.01){
            peakState = "good";
        }

        if(this.el && this.el.style && this.el.style.setProperty){
            this.el.style.setProperty("--peak-meter-level", normalizedLevel.toFixed(4));
            this.el.setAttribute("data-peak-state", peakState);
        }
        this.$el.toggleClass("is-active", normalizedLevel > 0.01);
        this.$el.toggleClass("is-warning", peakState === "warning");
        this.$el.toggleClass("is-danger", peakState === "danger");

    },



    render : function() {
        const templateParams = {};
        this.$el.html(this.compiledTemlate(templateParams));
        this.setElement(this.$el.find("div").first());
        return this;
    }

});
export default PeakMeterWidgetView;
